module.exports = (s) => {
  return [
    {
      name: '名称',
      value: 'name',
    },
    {
      name: '状态',
      value: 'status',
      width: 80,
      format: (row) => {
        const { status } = row;
        const status_map = {
          1: '提交',
          2: '成功',
          3: '失败',
          6: '重试中',
        };
        const font_color_map = {
          2: 'color-green',
          3: 'color-red',
        };
        const h = s.$createElement;
        const ele = h('span', { class: font_color_map[status] || '' }, status_map[status]);
        return ele;
      },
    },
    {
      name: '原因',
      value: 'reason',
      format: (row) => {
        const { reason, status } = row;
        return [1, 2].includes(status) ? '-' : reason;
      },
    },
  ];
};
